module.exports = __webpack_public_path__ + "static/media/t5.dd01b7f3.jpg";